/**
 * @file plugins.js
 * @author Jake Stark
 * @desc load up all the reports plugins we have!
*/

/**
 * @module plugins
 * @desc load up all the reports plugins we have!
 */

define('plugins/all',[
	// libraries
	"underscore",

	// modules
	"cardboard/util",

	// report plugins
	"plugins/childDemographics", "plugins/familyDemographics", "plugins/programParticipation", "plugins/summaryReport", "plugins/economicFoodAssistance", "plugins/birthOutcomes", "plugins/maternalTraitsAttendance", "plugins/maternalTraitsProficiency", "plugins/ECSEto3rdGrade", /* "plugins/KEPBirthOutcomes", */ "plugins/thirdGradeEdStatus", "plugins/deafHardOfHearing", "plugins/deafHardOfHearingPreK", "plugins/kgAttend", "plugins/earlyChildhoodScreening", "plugins/scholarships", "plugins/childProtectionInvolvement", "plugins/parentAware"
],
function (_,
		  Util,
		  ChildDemographicsPlugin, FamilyDemographicsPlugin, ProgramParticipationPlugin, SummaryReportPlugin, EconomicFoodAssistancePlugin, BirthOutcomesPlugin, MaternalTraitsAttendancePlugin, MaternalTraitsProficiencyPlugin, EcseTo3rdGradePlugin, /* KEPBirthOutcomesPlugin, */ thirdGradeEdStatusPlugin, deafHardOfHearingPlugin, deafHardOfHearingPreKPlugin, kgAttendPlugin,  earlyChildhoodScreeningPlugin, scholarshipsPlugin, childProtectionInvolvementPlugin, parentAwarePlugin
) {
	console.log("MODULE: plugins");

	var exports = {
		/** plugin registry: this gets built out below. This is used for
		 * matching a URL fragment to a plugin request! */
		plugins: {
		/*	vennDiagram: VennDiagramTest,*/
			childDemographics: ChildDemographicsPlugin,
			familyDemographics: FamilyDemographicsPlugin,
			programParticipation: ProgramParticipationPlugin,
            summaryReport: SummaryReportPlugin,
            economicFoodAssistance: EconomicFoodAssistancePlugin,
			birthOutcomes: BirthOutcomesPlugin,
			maternalTraitsAttendance: MaternalTraitsAttendancePlugin,
			maternalTraitsProficiency: MaternalTraitsProficiencyPlugin,
			ECSEto3rdGrade: EcseTo3rdGradePlugin,
			thirdGradeEdStatus: thirdGradeEdStatusPlugin,
			deafHardOfHearing: deafHardOfHearingPlugin,
			deafHardOfHearingPreK: deafHardOfHearingPreKPlugin,
			/* KEPBirthOutcomes: KEPBirthOutcomesPlugin, */
            kgAttend: kgAttendPlugin, 
            earlyChildhoodScreening: earlyChildhoodScreeningPlugin, 
			scholarships: scholarshipsPlugin,
			childProtectionInvolvement: childProtectionInvolvementPlugin,
            parentAware: parentAwarePlugin
		},

		/** add an aliases object to match alternative plugin IDs this gets
		 * populated below.
		 * @example "alias": "real name" */
		aliases: {}
	};

	// build the hash of plugin aliases
	Util.Plugins.recordAliases(exports);

	return exports;
});

